import {safeAsyncGet, safeGet, sha256Hex} from "../utils";
import {renderAudioFingerprint} from "./audio";
import {renderCanvasFingerprint} from "./canvas";
import {renderFontsFingerprint} from "./fonts";
import {renderNavigatorFingerprint} from "./navigator";
import {renderScreenFingerprint} from "./screen";
import {renderWebGlFingerprint} from "./webgl";

export interface FingerprintHashes {
  audio: string;
  canvas: string;
  webgl: string;
  fonts: string;
  navigator: string;
  screen: string;
}

export async function generateFingerprints(): Promise<FingerprintHashes> {
  const [audio, canvas, webgl, navigatorHash, fonts, screen] = await Promise.all([
    safeAsyncGet(() => renderAudioFingerprint()).then(value => sha256Hex(value ?? '')),
    sha256Hex(safeGet(() => renderCanvasFingerprint()) ?? ''),
    sha256Hex(safeGet(() => renderWebGlFingerprint()) ?? ''),
    sha256Hex(safeGet(() => renderNavigatorFingerprint()) ?? ''),
    sha256Hex(safeGet(() => renderFontsFingerprint()) ?? ''),
    sha256Hex(safeGet(() => renderScreenFingerprint()) ?? ''),
  ]);
  return {audio, canvas, webgl, navigator: navigatorHash, fonts, screen};
}
